import React, { useCallback } from "react";

import PageWrapper from "../../../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import { CONTENT_MANAGEMENT_ID } from "@duosoftbg/nacid-components";
import { VIEW_TYPES } from "../../../../../config/view/types";
import useViewDataObject from "../../../../../hooks/redux/useViewDataObject";
import { getContentManagementDataById } from "../../../../../axios/api/services";
import ViewPageWrapper from "../../../contacts/ViewPageWrapper";
import ContactsForm from "./ContactsForm";

const ContactsManagement = () => {
  const { t } = useTranslation();

  const viewType = VIEW_TYPES.CONTACTS_EDIT;
  const { object, data: contacts } = useViewDataObject(viewType);
  const serviceFn = useCallback(getContentManagementDataById(CONTENT_MANAGEMENT_ID.CONTACTS), []);

  return (
    <PageWrapper title={t("t.page.contacts.edit")}>
      <ViewPageWrapper viewType={viewType} serviceFn={serviceFn} object={object}>
        {contacts && <ContactsForm contacts={contacts}></ContactsForm>}
      </ViewPageWrapper>
    </PageWrapper>
  );
};

export default ContactsManagement;
